<nav class="navbar navbar-expand-lg navbar-light bg-light">
  <a class="navbar-brand" routerLink="/admin/codes">Codes</a>

  <span class="mr-auto">
    <button mat-raised-button color="primary" id="add" [matMenuTriggerFor]="linkMenu" class="m-1 mr-2">
      <mat-icon>add</mat-icon> Add Code
    </button>

    <mat-menu #linkMenu="matMenu">
      <button mat-menu-item [routerLink]="['/admin', 'codes', 'new', 'edit']">
        Create New
      </button>
      <button mat-menu-item (click)="addMany()">
        Add many Codes
      </button>
    </mat-menu>

    <mat-menu #appMenu="matMenu">
      <ng-container *ngIf="dataSource.only_archived == 'false'; else restoreManyOption">
        <button mat-menu-item (click)="dataSource.selectAllToggle()">
          <mat-icon *ngIf="dataSource.isAllSelected()"> clear_all</mat-icon><mat-icon *ngIf="!dataSource.isAllSelected()">select_all</mat-icon>
          {{ dataSource.isAllSelected() ? 'Deselect' : 'Select' }} All
        </button>
        <button mat-menu-item matTooltip="Unlink selected" (click)="unlinkMany()" [disabled]="!dataSource.selection.hasValue()">
          <mat-icon>link_off</mat-icon> Unlink selected
        </button>
        <button mat-menu-item matTooltip="Delete selected" (click)="deleteMany()" [disabled]="!dataSource.selection.hasValue()">
          <mat-icon>delete</mat-icon> Delete selected
        </button>
      </ng-container>

      <ng-template #restoreManyOption>
        <button mat-menu-item matTooltip="Restore Selected" (click)="onRestoreSelected()" [disabled]="!dataSource.selection.hasValue()">
          <mat-icon>restore</mat-icon> Restore Selected
        </button>
      </ng-template>
    </mat-menu>

    <button mat-button class="m-1 mr-2" [matMenuTriggerFor]="appMenu" matTooltip="Use this menu to select/deselect Codes." style="min-width: 120px">
      <mat-icon>more_vert</mat-icon> List Menu
    </button>
  </span>

  <button mat-raised-button type="button" class="m-1 mr-lg-3" (click)="onOpenFilters()" matTooltip="Click this button to display filter options.">
    <mat-icon>filter_list</mat-icon> Filter
  </button>

  <form tourAnchor="tour.search" class="form-inline mx-1 my-0" (ngSubmit)="dataSource.getData(true)">
    <input
      class="form-control ml-0 mr-2 my-1"
      type="search"
      [(ngModel)]="dataSource.search"
      name="search"
      placeholder="Search"
      aria-label="Search" />

    <button
      mat-raised-button
      color="secondary"
      type="submit"
      class="mx-0 my-1"
      matTooltip="Search">
      <mat-icon>search</mat-icon> Search
    </button>
  </form>
</nav>

<div class="mat-elevation-z8 scroll-box">
  <table
    mat-table
    [dataSource]="dataSource"
    style="width: 100%"
    matSort
    matSortActive="name"
    matSortDisableClear>
    <ng-container matColumnDef="select">
      <th mat-header-cell *matHeaderCellDef [style.width.px]="65">
        <mat-checkbox
          (change)="$event ? dataSource.selectAllToggle() : null"
          [checked]="dataSource.selection.hasValue() && dataSource.isAllSelected()"
          [indeterminate]="dataSource.selection.hasValue() && !dataSource.isAllSelected()">
        </mat-checkbox>
      </th>
      <td mat-cell *matCellDef="let row">
        <mat-checkbox
          (click)="$event.stopPropagation()"
          (change)="$event ? dataSource.selection.toggle(row.id) : null"
          [checked]="dataSource.selection.isSelected(row.id)"
          appMarginRight>
        </mat-checkbox>
      </td>
    </ng-container>

    <ng-container matColumnDef="id">
      <th mat-header-cell *matHeaderCellDef class="no-padding" mat-sort-header>
        ID
      </th>
      <td mat-cell *matCellDef="let code" class="no-padding">
        {{ code.id }}
      </td>
    </ng-container>

    <ng-container matColumnDef="paper_id">
      <th mat-header-cell *matHeaderCellDef class="no-padding" mat-sort-header>
        Short Hash
      </th>
      <td mat-cell *matCellDef="let code" class="no-padding">
        {{ code.paper_id | uppercase }}
        <button mat-icon-button
          ngxClipboard
          [cbContent]="code.paper_id"
          matTooltip="Copy to Clipboard"
          (click)="copied(code.paper_id)">
          <mat-icon>file_copy</mat-icon>
        </button>
      </td>
    </ng-container>

    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef class="no-padding" mat-sort-header>
        Name
      </th>
      <td mat-cell *matCellDef="let code" class="no-padding">
        {{ code.name }}
      </td>
    </ng-container>

    <ng-container matColumnDef="feature">
      <th mat-header-cell *matHeaderCellDef class="no-padding" mat-sort-header>
        Feature
      </th>
      <td mat-cell *matCellDef="let code" class="no-padding">
        {{ code.feature }}
      </td>
    </ng-container>

    <ng-container matColumnDef="type">
      <th mat-header-cell *matHeaderCellDef class="no-padding" mat-sort-header>
        Type
      </th>
      <td mat-cell *matCellDef="let code" class="no-padding">
        {{ code.type }}
      </td>
    </ng-container>

    <ng-container matColumnDef="site.name">
      <th mat-header-cell *matHeaderCellDef class="no-padding">
        {{ utils.getLangTerm('parent-child-sites-combined.singular', 'Site') }}
      </th>
      <td mat-cell *matCellDef="let code" class="no-padding">
        <a routerLink="/admin/sites/{{ code?.site?.id }}/details" matTooltip="Edit the information." matTooltipPosition="above">
          {{ code.site?.name }}
        </a>
      </td>
    </ng-container>

    <ng-container matColumnDef="asset">
      <th mat-header-cell *matHeaderCellDef class="no-padding">
        Asset
      </th>
      <td mat-cell *matCellDef="let code" class="no-padding">
        {{ code.asset?.name }}<span *ngIf="code.asset?.code"> ({{ code.asset.code }})</span>
      </td>
    </ng-container>

    <ng-container matColumnDef="site.account.name">
      <th mat-header-cell *matHeaderCellDef class="no-padding">
        Account
      </th>
      <td mat-cell *matCellDef="let code" class="no-padding">
        <a *ngIf="code.account?.id" routerLink="/admin/accounts/{{ code.account?.id }}/edit">
          {{ code.account?.name }}
        </a>
      </td>
    </ng-container>

    <ng-container matColumnDef="date_created">
      <th mat-header-cell mat-sort-header *matHeaderCellDef matTooltip="Sort by Date Created">
        Date Created
      </th>
      <td mat-cell *matCellDef="let code">
        {{ (code.date_created * 1000) | timezoneConvertShort }} <br>
        {{ (code.date_created * 1000) | timezoneConvertUTCShort }}
      </td>
    </ng-container>

    <ng-container matColumnDef="buttons">
      <th mat-header-cell *matHeaderCellDef [style.width.px]="300">Actions</th>
      <td mat-cell *matCellDef="let code">
        <ng-container *ngIf="dataSource.only_archived == 'false'; else restoreOption">
          <button type="button" mat-button [routerLink]="'/admin/codes/' + code.id + '/view'">
            View
          </button>

          <button type="button" mat-button [routerLink]="'/admin/codes/' + code.id + '/edit'">
            Edit
          </button>

          <button type="button" mat-button [disabled]="!code.site" (click)="unlink(code.id)">
            Unlink
          </button>

          <button type="button" mat-button [disabled]="code.asset" (click)="delete(code)">
            Delete
          </button>
        </ng-container>

        <ng-template #restoreOption>
          <button type="button" mat-button (click)="onRestore(code)">
            Restore
          </button>
        </ng-template>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>

  <mat-paginator
    [length]="dataSource?.total | async"
    [pageSize]="dataSource.limit"
    [pageSizeOptions]="dataSource.pageSizeOptions"
    showFirstLastButtons>
  </mat-paginator>
</div>
